import { render, staticRenderFns } from "./DocInfo.vue?vue&type=template&id=030a5c37&"
import script from "./DocInfo.vue?vue&type=script&lang=ts&"
export * from "./DocInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports